import { createFileRoute } from "@tanstack/react-router";
import { SEOPage } from "@/components/site/SEOPage";
import { Smartphone, LayoutGrid, Zap } from "lucide-react";

const ArticlePage = () => {
  const breadcrumbs = [
    { label: "Elite", href: "/" },
    { label: "Blog", href: "/blog" },
    { label: "Painel IPTV com Aplicativo Próprio", href: "/blog/painel-iptv-com-aplicativo-proprio" }
  ];

  const sections = [
    {
      title: "O Poder de uma Marca Profissional",
      type: "grid" as const,
      content: (
        <>
          {[
            { t: "Fidelização", d: "Clientes que usam um app exclusivo como o One X raramente trocam de servidor.", i: <Zap /> },
            { t: "Credibilidade", d: "Apresente uma solução personalizada ao invés de usar aplicativos genéricos e instáveis.", i: <Smartphone /> },
            { t: "Estabilidade", d: "Nossos apps são otimizados especificamente para o nosso servidor, garantindo zero latência.", i: <LayoutGrid /> }
          ].map((item, i) => (
            <div key={i} className="p-8 rounded-3xl bg-white/[0.02] border border-white/5">
              <div className="w-12 h-12 rounded-2xl bg-electric/10 text-electric flex items-center justify-center mb-6">
                {item.i}
              </div>
              <h3 className="text-xl font-bold mb-3">{item.t}</h3>
              <p className="text-muted-foreground text-sm">{item.d}</p>
            </div>
          ))}
        </>
      )
    }
  ];

  return (
    <SEOPage
      category="Painel IPTV com Aplicativo Próprio"
      title="Painel IPTV com Aplicativo Próprio: Por que Isso é Vital?"
      subtitle="Entenda como os aplicativos One X e P2 PRO transformam a experiência do seu cliente e garantem suas renovações."
      heroImage="https://images.unsplash.com/photo-1512941937669-90a1b58e7e9c?auto=format&fit=crop&q=80&w=1200"
      introParagraphs={[
        "No mercado de IPTV, a primeira impressão é a que fica. Se o seu cliente precisa baixar um aplicativo difícil de configurar ou cheio de propagandas, ele provavelmente não vai renovar.",
        "A P2 PRO investe pesado no desenvolvimento de aplicativos próprios, oferecendo aos nossos revendedores uma ferramenta de elite que facilita o uso para o cliente final e aumenta drasticamente a taxa de retenção."
      ]}
      benefits={[
        { title: "Interface Amigável", description: "Design moderno e intuitivo, fácil de usar em Smart TVs e Celulares." },
        { title: "Segurança", description: "Aplicativos homologados e seguros para o usuário final." }
      ]}
      howItWorks={[
        { title: "Download", description: "Forneça o link direto ou acesso via lojas oficiais para seu cliente." },
        { title: "Login", description: "O cliente entra com os dados gerados no seu painel pós-pago." }
      ]}
      diferenciais={[
        { title: "Apps Flagship", description: "One X e P2 PRO: a tecnologia de streaming mais avançada de 2026." }
      ]}
      faq={[
        { question: "Os aplicativos funcionam em iPhone e Android?", answer: "Sim, nossos aplicativos são multiplataforma, garantindo que você não perca vendas por incompatibilidade de dispositivo." }
      ]}
      breadcrumbs={breadcrumbs}
      sections={sections}
      ctaTitle="🚀 Quer Oferecer a Melhor Experiência aos Seus Clientes?"
      ctaDescription="Dê ao seu cliente o que há de melhor. Use nossos apps próprios e fidelize sua base."
      ctaButtonText="Testar Aplicativos"
    />
  );
};

export const Route = createFileRoute("/blog/painel-iptv-com-aplicativo-proprio")({
  head: () => ({
    meta: [
      { title: "Painel IPTV com Aplicativo Próprio - Retenção e Marca | P2 PRO" },
      { name: "description", content: "Aprenda por que usar painel IPTV com aplicativo próprio é fundamental para sua revenda. Conheça o One X e P2 PRO, os melhores apps de 2026." }
    ],
  }),
  component: ArticlePage,
});
